// extracted by mini-css-extract-plugin
module.exports = {"root":"IntegrationCase_root__GSqYS","active":"IntegrationCase_active__n649I","aside":"IntegrationCase_aside__lWQGG","actionBtn":"IntegrationCase_actionBtn__y7Nn_"};